import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import React from "react";
import { matchSorter } from 'match-sorter';

export default function SelectableLimitSearch(props) {
  const [inputValue, setInputValue] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const loading = open && props?.data?.values?.length === 0 ? true : false;
  var optionLabel = props?.fieldLabel || "optionname"

  React.useEffect(() => {
    let active = true;
    if (!loading) {
      return undefined;
    }
    if (active) {
      props?.loading();
    }
    return () => {
      active = false;
    };
    //eslint-disable-next-line
  }, [loading, props?.data?.value]);


  const filterOptions = (options, { inputValue }) => {
    let vals = matchSorter(options, inputValue, { keys: props?.keys });
    return vals
  };
  const charVal = inputValue === "" || inputValue?.length >= 4
  const allowOpen = open && charVal

  return (
    <React.Fragment>
      <Autocomplete
        multiple={props?.multiple}
        freeSolo={props?.disabled}
        size="small"
        limitTags={props?.limitTags || 3}
        disabled={props?.disabled}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        noOptionsText={ (inputValue === "" &&
          inputValue?.length < 4) ? "Type at least 4 characters to search" : props?.noOptionText || "No Options"}
        value={
          props?.multiple
            ? Array.isArray(props?.value)
              ? props?.value
              : []
            : props?.value || null
        }
        id={props?.id}
        name={props?.name}
        disableClearable={props?.disableClearable}
        openOnFocus
        open={allowOpen}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        onChange={(event, value) => props?.onChangeEvent(props?.name, value)}
        filterSelectedOptions
        getOptionLabel={(option) => {
          if (option && option?.[optionLabel]) {
            return option?.[optionLabel];
          } else {
            return "";
          }
        }}
        options={
          inputValue?.length >= 4 && props?.data && props?.data?.values?.length > 0 ? props?.data?.values : []
        }
        loading={props?.data?.load}
        renderInput={(params) => (
          <TextField
            {...params}
            label={props?.label}
            placeholder={props?.placeholder} 
            autoFocus={props?.autoFocus}
            required={props?.required}
            variant={props?.variantType ? props?.variantType : "outlined"}
            name={props?.name}
            onBlur={props?.onBlur}
            error={props?.error}
            size={props?.size}
            helperText={props?.helperText}
            inputprops={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {props?.data?.load ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps?.endAdornment}
                </React.Fragment>
              ),
            }}
             sx={{
               ...(props?.customBackground  && {
                "& .MuiOutlinedInput-root": {
                  backgroundColor: props?.disabled ? "inherit" : "#ffffff",
                },
                "& .MuiOutlinedInput-root.Mui-disabled": {
                  backgroundColor: "inherit",
                },
              }),
              ...props?.styles,
            }}
          />
        )}
        {...(props?.filterOptions && { filterOptions: filterOptions })}
        {...(props?.renderOption && { renderOption: props?.renderOption })}
        {...(props?.isOptionEqualToValue && { isOptionEqualToValue: props?.isOptionEqualToValue })}
        {...(props?.grouping ? { groupBy: props?.groupByFn || ((option) => option?.user_type) } : {})}
      />
    </React.Fragment>
  );
}